<script setup>
import { useProductStore } from '../../../stores/fpe';
import { ElCollapseItem, ElSwitch } from 'element-plus';
import { ArrowRightBold } from '@element-plus/icons-vue';
import Uploader from '../../utility/media-uploader.vue';
import WYSIWYG from '../../utility/wysiwyg.vue';
import { storeToRefs } from 'pinia';
import { computed, defineProps, ref } from 'vue';

const store = useProductStore();
const { strings, selectedVariationDetails } = storeToRefs(store);
// const props = defineProps({
//     variationData: {
//         type: Object,
//         default: null,

//     }
// });
const isVirtual = ref(selectedVariationDetails.value.virtual === true ? true : false);
const isDownloadable = ref(selectedVariationDetails.value.downloadable === true ? true : false);
const isEnabled = ref(selectedVariationDetails.value.enabled);

</script>
<template>
    <el-collapse-item :title="strings.section_title_general" class="pe-variation-general-deatils" name="general" :icon="ArrowRightBold">
            <div class="fpe-variation-details-inline">
                <div class="fpe-field-wrapper" data-field="variation-image">
                    <label>{{ strings.label_upload_image }}</label>
                    <Uploader :multiple="false" v-model="selectedVariationDetails.image" label="Upload Product Image" />
                </div>
                <div class="fpe-variation-product-type">
                    <div class="fpe-field-wrapper fpe_virtual label-inline" data-field="virtual">
                        <ElSwitch v-model="selectedVariationDetails.virtual" />   
                        <label>{{ strings.label_variation_virtual }} </label>
                    </div>
                    <div class="fpe-field-wrapper fpe_download label-inline" data-field="download">
                        <ElSwitch v-model="selectedVariationDetails.downloadable" />   
                        <label>{{ strings.label_variation_download }}</label>
                    </div>
                    <div class="fpe-field-wrapper fpe_exclude label-inline" data-field="exclude">
                        <ElSwitch v-model="selectedVariationDetails.enabled" />   
                        <label>{{ strings.label_variation_enabled }}</label>
                    </div>
                </div>
            </div>
            <div class="fpe-field-wrapper" data-field="variation-description">
                <label>{{ strings.label_description }}</label>
                <WYSIWYG v-model="selectedVariationDetails.description" :value="selectedVariationDetails.description" class="fpe-editor" editor_id="fpe_variation_description" />
            </div>
            <div class="fpe-field-wrapper" data-field="variation-sku">
                <label>{{ strings.label_sku }}</label>
                <ElInput v-model="selectedVariationDetails.sku" />
            </div>
            <div class="fpe-field-wrapper" data-field="variation-global-unique-id">
                <label>{{ strings.label_global_unique_id }}</label>
                <ElInput v-model="selectedVariationDetails.global_unique_id" />
            </div>
    </el-collapse-item>
</template>